import { render, staticRenderFns } from "./StatusManager.vue?vue&type=template&id=61851e7a&scoped=true"
import script from "./StatusManager.vue?vue&type=script&lang=js"
export * from "./StatusManager.vue?vue&type=script&lang=js"
import style0 from "./StatusManager.vue?vue&type=style&index=0&id=61851e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61851e7a",
  null
  
)

export default component.exports